module.exports = "/assets/data/a1c05a62e26ae4d4553d6053b08ad414-M26.data.json";